// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1bLNb","large":"styles_large__1-Y06"};